module.exports = __webpack_public_path__ + "img/collection-engagementRingsRedgold.863a2c2.webp";